<template>
  <div>
    <sys-data-table
      v-model="produtos_selecionados"
      :headers="HEADERS_COMPUTED"
      :items="desserts"
      :search="filtros.pesquisar"
      :fixed-header="true"
      :height="alturaDaJanela - 170"
      :item-height="35"
      :loading="loading"
      item-key="idproduto"
      show-select
    >
      <template #top>
        <p class="subtitle-1 font-wieght-medium">
          <v-icon left>mdi-package-variant-closed</v-icon>
          Lista de Produtos
        </p>

        <v-spacer />

        <v-text-field
          v-model="filtros.pesquisar"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          clearable
          outlined
          class="mt-2 mb-0"
          style="max-width: 450px;"
        />

        <Filtros
          v-model="filtros"
          @reiniciar-tela-compra-parametrizacao="inicializacao(); loading = true;"
        />
      </template>

      <template #item.tempo_medio_ressuprimento="{ item }">
        <EditarRessuprimento
          :item="item"
          :produtos_selecionados="produtos_selecionados"
          @atualizar-tela-inicial="atualizarTelaInicial()"
        />
      </template>

      <template #item.lote_minimo="{ item }">
        <EditarLoteMinimo
          :item="item"
          :produtos_selecionados="produtos_selecionados"
          @atualizar-tela-inicial="atualizarTelaInicial()"
        />
      </template>

      <template #item.percentual="{ item }">
        <EditarInfluenciarProjecao
          :item="item"
          :produtos_selecionados="produtos_selecionados"
          @atualizar-tela-inicial="atualizarTelaInicial()"
        />
      </template>

      <template #item.acoes="{ item }">
        <EditarMultiplosProdutos
          :item="item"
          :produtos_selecionados="produtos_selecionados"
          @atualizar-tela-inicial="atualizarTelaInicial()"
        />
      </template>
    </sys-data-table>

  </div>
</template>

<script>
import Responsividade from '@/helpers/ResponsiveHeight';
import Filtros from "./Includes/Filtros.vue";
import EditarLoteMinimo from './Dialog/EditarLoteMinimo.vue';
import EditarMultiplosProdutos from './Dialog/EditarMultiplosProdutos.vue';
import EditarRessuprimento from './Dialog/EditarRessuprimento.vue';
import EditarInfluenciarProjecao from "./Dialog/EditarInfluenciarProjecao.vue"
import { buscarListaDeProdutos } from "./Api";

export default {
  mixins: [Responsividade],
  components: {
    Filtros,
    EditarMultiplosProdutos,
    EditarLoteMinimo,
    EditarRessuprimento,
    EditarInfluenciarProjecao
  },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaAreaDeCompras", this.$route.path);
    this.inicializacao();
  },
  data: () => ({
    headers: [
      { text: 'Segmento', value: 'descricao_segmento' },
      { text: 'Fornecedor', value: 'descricao_fornecedor' },
      { text: 'Comprador', value: 'descricao_comprador' },
      { text: 'Produto', value: 'descricao_produto' },
      { text: 'Ressuprimento', value: 'tempo_medio_ressuprimento' },
      { text: 'Lote Minimo', value: 'lote_minimo' },
      { text: 'Influenciar projeção', value: 'percentual' },
      // { text: 'Data Limite', value: 'data_limite' },
      // { text: '', value: 'acoes' },
    ],
    desserts: [],
    produtos_selecionados: [],
    loading: true,
    filtros: {
      pesquisar: '',
      grupo_x_filial: false,
      grupo: 1,
      filial: 1,
      segmentos: [],
      fornecedores: [],
      compradores: []
    },
    editar: {}
  }),
  computed: {
    HEADERS_COMPUTED() {
      let h = [];

      if (this.filtros.grupo_x_filial) {
        h.push({ text: 'Id Filial', value: 'filial' });
      } else {
        h.push({ text: 'Id Grupo', value: 'id_grupo' });
      }

      return h.concat(this.headers);
    }
  },
  watch: {
    "filtros.grupo_x_filial"() {
      this.desserts = [];
    }
  },
  methods: {
    inicializacao() {
      this.produtos_selecionados = [];
      this.filtros.pesquisar = '';

      this.$store.dispatch(
        'loading/addRequisicao',
        buscarListaDeProdutos(this.filtros)
          .then((produtos) => this.desserts = produtos)
          .catch(() => this.Helpers.logout())
          .finally(() => this.loading = false)
      )
    },
    atualizarTelaInicial() {
      this.desserts = [];
      this.loading = true;
      this.inicializacao();
    }
  }
}
</script>

<style>

</style>
